import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: 'https://ewallet-v2-api.kaxaa.com/',
    // baseURL: 'http://localhost:5000/', // Use your local or production API URL
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
});

const clearLegacyAuthStorage = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('auth_token');
};

// Response interceptor to handle token expiration and errors
axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
            originalRequest._retry = true;
            clearLegacyAuthStorage();

            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }

        if (error.response) {
            console.error('API Error:', error.response.data);

            switch (error.response.status) {
                case 403:
                    console.error('Access forbidden');
                    break;
                case 404:
                    console.error('Resource not found');
                    break;
                case 500:
                    console.error('Server error');
                    break;
                default:
                    break;
            }
        } else if (error.request) {
            console.error('Network Error - No response received:', error.message);
        } else {
            console.error('Request Error:', error.message);
        }

        return Promise.reject(error);
    }
);

// Public requests still send credentials so HttpOnly auth cookies can be set on login.
export const publicRequest = (config) => axiosInstance(config);

export const authenticatedRequest = (config) => axiosInstance(config);

export { clearLegacyAuthStorage };

export default axiosInstance;
